var _path, _path2, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIsland1 = function SvgIsland1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 221,
    height: 114,
    viewBox: "0 0 221 114",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-184 75.3601C-184 75.3601 85.7152 75.8204 220.573 75.3601C216.573 81.9196 179.43 80.0086 164.192 82.9777C148.953 85.9467 156.001 98.1681 93.3343 96.0276C30.6674 93.8872 64.3818 113.083 4.38158 113.083C-38.9639 113.082 -95.9997 96.4421 -120.952 104.175C-145.905 111.909 -184 75.3601 -184 75.3601Z",
    fill: "url(#paint0_linear)",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-184 75.8317C-184 75.8317 85.7152 74.9168 220.573 75.8317C216.573 62.7947 179.43 66.5928 164.192 60.6918C148.953 54.7908 156.001 30.5008 93.3343 34.755C30.6674 39.0091 64.3818 0.858154 4.38158 0.858399C-38.9639 0.858576 -95.9997 33.9312 -120.952 18.5613C-145.905 3.19128 -184 75.8317 -184 75.8317Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 260.889,
    y1: -6.72761,
    x2: 45.3342,
    y2: 254.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76A589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4779A4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 205.012,
    y1: 91.3921,
    x2: -67.5144,
    y2: 36.8473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BA585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4779A4",
    stopOpacity: 0
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIsland1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/island1.14341189.svg";
export { ForwardRef as ReactComponent };